/**
 * 业务编号回退说明抽屉（ADM-24，admin-reversal-and-ledger-ui:SC-16）。
 *
 * 业务编号指向的单据不存在或不可解析（如历史汇总引用）时打开只读说明，
 * 不报错不白屏；对齐原型 BusinessRefFallbackDrawer。
 */
import { Alert, Descriptions, Drawer } from 'antd';
import { ledgerBusinessRefLabel } from './LedgerDetailDrawer';
import type { LedgerBusinessRefType } from '../../api/entitlementLedger.api';

export interface BusinessRefFallbackDrawerProps {
  open: boolean;
  refType: LedgerBusinessRefType | null;
  refId: string | null;
  onClose: () => void;
}

export function BusinessRefFallbackDrawer({
  open,
  refType,
  refId,
  onClose,
}: BusinessRefFallbackDrawerProps) {
  return (
    <Drawer title="业务编号说明" open={open} onClose={onClose} width={480}>
      <Alert
        type="info"
        showIcon
        message="该业务编号为历史汇总或演示引用，系统中无独立业务单据可打开。"
        style={{ marginBottom: 16 }}
      />
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="业务来源">
          {refType ? ledgerBusinessRefLabel[refType] ?? refType : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="业务编号">{refId ?? '-'}</Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}
